import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class Spinner {
    private spinnerSubject = new BehaviorSubject<boolean>(false);
    spinner$ = this.spinnerSubject.asObservable();

    show() {
        this.spinnerSubject.next(true);
    }

    hide() {
        this.spinnerSubject.next(false);
    }
}
